$(document).on("ready", function () {
    $("section.main.films.index .scroll-to-cinemas").click(function (event) {
        event.preventDefault();
        $(window).scrollTo("section.main.films.index .cinemas-list", 700);
    });
});